import React from "react";

import ImportExportMenu from "Components/Common/DataImport/ImportExportMenu";
import { DataImportConfig } from "Components/Common/DataImport/dataImportFields";
import {
  exportContractTypesToCSV,
  importContractType,
} from "common/services/contracts.service";

const importConfig: DataImportConfig = {
  title: "Contract Types",
  entityLabel: "contract type",
  icon: "ri-file-text-line",
  templateFile: "contract_types_import_template.csv",
  importFn: importContractType,
  fields: [
    {
      key: "name",
      label: "Name",
      required: true,
      hint: "Must be unique across contract types",
    },
    { key: "description", label: "Description" },
  ],
};

/** Import/export menu for the contract types table. */
const Import = ({ apiParams }: { apiParams?: any }) => (
  <ImportExportMenu
    resource="contract-type"
    config={importConfig}
    exportFn={exportContractTypesToCSV}
    exportFileName="Contract_Types_Export.csv"
    apiParams={apiParams}
  />
);

export default Import;
